module.exports = __webpack_public_path__ + "static/img/drilling2.413c9605.png";